// T47: pierwsze logowanie pracownika eventowego — komunikat (tekst Maćka, dosłownie), potem
// formularz z danymi kontaktowymi. Bez kompletu nie da się przejść dalej (ProtectedRoute).
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

const INTRO = 'Potrzebujemy od Ciebie kilku informacji, które mogą nam ułatwić kontakt z Tobą i działanie w momencie jakiegoś kryzysu, lub zwyczajnie, gdy zaśpisz. Dlatego wypełnij rzetelnie tabele, która pojawi się zaraz. To naprawdę może nam pomóc';

export default function OnboardingPage() {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    phone: user?.phone || '', emergencyPhone: user?.emergencyPhone || '', address: user?.address || '',
    birthDate: user?.birthDate ? String(user.birthDate).slice(0, 10) : '', studentStatus: user?.studentStatus || '',
    gender: user?.gender || '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const missing = [];
  if (!form.phone.trim()) missing.push('telefon');
  if (!form.emergencyPhone.trim()) missing.push('telefon kryzysowy');
  if (form.address.trim().length < 5) missing.push('adres');
  if (!form.birthDate) missing.push('data urodzenia');
  if (!form.studentStatus) missing.push('uczeń / student');
  if (!form.gender) missing.push('płeć');
  const ready = missing.length === 0;
  const age = form.birthDate ? Math.floor((Date.now() - new Date(form.birthDate).getTime()) / (365.25 * 86400000)) : null;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setSaving(true);
    try {
      await api.completeProfile(form);
      await refreshUser();
      navigate('/');
    } catch (err) { setError(err.message); }
    setSaving(false);
  };

  return (
    <div className="login-page">
      <div className="login-card" style={{ maxWidth: 560 }}>
        <div style={{ fontSize: 32, textAlign: 'center', marginBottom: 8 }}>🎪</div>
        <div className="login-title">Cześć, {user?.firstName}!</div>

        {step === 1 && (
          <>
            <div className="login-sub" style={{ marginBottom: 14 }}>Zanim przejdziesz dalej</div>
            <div style={{ fontSize: 14, lineHeight: 1.6, color: '#1E293B', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 10, padding: 16 }}>
              {INTRO}
            </div>
            <div style={{ fontSize: 11, color: '#64748B', marginTop: 10 }}>
              Dane widzi tylko Twój koordynator i właściciele firmy. Nie trafiają do dziennika zdarzeń.
            </div>
            <button className="btn btn-primary" style={{ width: '100%', marginTop: 16 }} onClick={() => setStep(2)}>Rozumiem, przechodzę do formularza</button>
            <button className="btn btn-ghost btn-sm" style={{ width: '100%', marginTop: 8 }} onClick={() => { logout(); navigate('/login'); }}>Wyloguj</button>
          </>
        )}

        {step === 2 && (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="login-sub">Uzupełnij wszystkie pola</div>
            {error && <div className="login-error">{error}</div>}
            <div className="input-group"><label>Twój numer telefonu *</label><input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="np. 600 100 200" autoFocus /></div>
            <div className="input-group">
              <label>Numer kryzysowy *</label>
              <input value={form.emergencyPhone} onChange={e => set('emergencyPhone', e.target.value)} placeholder="np. 600 300 400" />
              <div style={{ fontSize: 10, color: '#64748B', marginTop: 2 }}>Do osoby, która Cię obudzi, gdy zaśpisz, albo pomoże w kryzysie (rodzic, partner, współlokator). Inny niż Twój.</div>
            </div>
            <div className="input-group"><label>Adres zamieszkania *</label><input value={form.address} onChange={e => set('address', e.target.value)} placeholder="ulica, numer, miejscowość" /></div>
            <div className="flex gap-8 flex-wrap">
              <div className="input-group flex-1" style={{ minWidth: 150 }}><label>Data urodzenia *{age !== null && age >= 0 && <span style={{ color: '#64748B', fontWeight: 400 }}> — {age} lat</span>}</label><input type="date" value={form.birthDate} onChange={e => set('birthDate', e.target.value)} max={new Date().toISOString().slice(0, 10)} /></div>
              <div className="input-group flex-1" style={{ minWidth: 150 }}><label>Jesteś uczniem / studentem? *</label>
                <select value={form.studentStatus} onChange={e => set('studentStatus', e.target.value)}>
                  <option value="">— wybierz —</option><option value="PUPIL">Uczeń</option><option value="STUDENT">Student</option><option value="NONE">Nie, żadnym z nich</option>
                </select>
              </div>
              <div className="input-group flex-1" style={{ minWidth: 120 }}><label>Płeć *</label>
                <select value={form.gender} onChange={e => set('gender', e.target.value)}>
                  <option value="">— wybierz —</option><option value="K">Kobieta</option><option value="M">Mężczyzna</option>
                </select>
              </div>
            </div>
            {!ready && <div style={{ fontSize: 11, color: '#B45309' }}>Brakuje: {missing.join(', ')}</div>}
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={!ready || saving}>{saving ? 'Zapisywanie...' : 'Zapisz i przejdź do aplikacji'}</button>
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => setStep(1)}>← wróć</button>
          </form>
        )}
      </div>
    </div>
  );
}
